import { Component, inject } from '@angular/core';
import { COMMON_IMPORTS } from '../../Shared/common-imports';
import { ThemeService } from '../../Shared/Services/theme.service';
import { GlobalLoaderComponent } from '../../Shared/Components/global-loader/global-loader.component';
import { ImpersonationNotchComponent } from '../../Shared/Components/impersonation-notch/impersonation-notch.component';

@Component({
  selector: 'app-root',
  imports: [COMMON_IMPORTS, GlobalLoaderComponent, ImpersonationNotchComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class App {
  private readonly themeService = inject(ThemeService);
}
